import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import {textBold, textRegular} from 'theme/theme'; // eslint-disable-line
import theme from '../../../theme';
import Link from '../Link';

const LargeLabel = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
  color: ${theme.colors.black};
  font-size: ${theme.fontSizes.default};
  ${textRegular}
  line-height: 140%;
  ${(props) => props.isPrimary && css`
    color: ${theme.colors.primary};
  `}
  ${(props) => props.isLink && css`
    &:hover {
      cursor: pointer;
      color: ${theme.colors.primary};
    }
  `}
  @media (min-width: ${theme.breakpoints.desktop}) {
    font-size: ${theme.fontSizes.medium};
  }
`;
LargeLabel.propTypes = {
  isPrimary: PropTypes.bool,
  isLink: PropTypes.bool,
};
LargeLabel.defaultProps = {
  isPrimary: false,
  isLink: false,
};

const LargeLabelLink = styled(LargeLabel.withComponent(Link))`
  text-decoration: none;
  &:hover {
    cursor: pointer;
    color: ${theme.colors.primary};
  }
`;
LargeLabelLink.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  isPrimary: PropTypes.bool,
  isLink: PropTypes.bool,
};
LargeLabelLink.defaultProps = {
  isPrimary: false,
  isLink: false,
};


export default LargeLabel;

export { LargeLabelLink };
